import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import PrintIcon from '@mui/icons-material/Print'
import { Box, Button, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { Fragment, useContext } from 'react'

import { CounterSalesContext } from '../../../providers/CounterSalesProvider/CounterSalesProvider'
import { formatCurrency } from '../../../utils'
import { getDueTotalFromPayments } from '../../RepairOrder/getDueTotalFromPayments'

interface Props {
  handleBack: () => void
  handleFinish: () => void
  isLoading: boolean
}

const CounterSaleConfirmation = ({
  handleBack,
  handleFinish,
  isLoading
}: Props) => {
  const { activeCounterSale } = useContext(CounterSalesContext)

  const openReceipt = () => {
    window.open(
      `/print.html?id=${activeCounterSale?.entry?.id}&type=counterSale`
    )
  }

  return (
    <Fragment>
      <Typography variant="h1" sx={{ mt: 2, mb: 1 }}>
        Order Confirmation
      </Typography>
      <Stack direction="column" alignItems="center" spacing={2}>
        <CheckCircleIcon />
        <Typography variant="h4">
          {`Balance: ${formatCurrency(
            getDueTotalFromPayments(
              activeCounterSale?.pricing?.payments,
              activeCounterSale?.pricing?.totalBeforeSurcharge
            ) || 0,
            true
          )}`}
        </Typography>
        <Button
          onClick={openReceipt}
          variant="contained"
          startIcon={<PrintIcon />}>
          Print Receipt
        </Button>
      </Stack>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button color="inherit" onClick={handleBack} sx={{ mr: 1 }}>
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />
        <Button disabled={isLoading} onClick={handleFinish}>
          Finish
        </Button>
      </Box>
    </Fragment>
  )
}

export default CounterSaleConfirmation
